module.exports = __webpack_public_path__ + "img/roller-coaster-graph.9e9d4f14.svg";